import { useBirthdayStore } from './birthdayStore'

interface Props { userId?: string | null; size?: 'sm' | 'md' | 'lg'; className?: string }
const SIZES = { sm: 'w-3.5 h-3.5 text-[9px]', md: 'w-4 h-4 text-[10px]', lg: 'w-6 h-6 text-sm' }

/**
 * Corner cake badge shown over an avatar on the user's birthday. Renders null
 * otherwise. Drop INSIDE a position:relative avatar container. Shared via
 * components/ so sibling repos consume it through sibling-rescue.
 */
export function BirthdayBadge({ userId, size = 'sm', className }: Props) {
  const isBirthday = useBirthdayStore(s => s.isBirthday(userId))
  if (!isBirthday) return null
  return (
    <span title="Birthday today" aria-label="Birthday today"
      className={`absolute -bottom-0.5 -right-0.5 flex items-center justify-center rounded-full bg-white shadow ${SIZES[size]} ${className ?? ''}`}>
      🎂
    </span>
  )
}

export default BirthdayBadge
